import { render, staticRenderFns } from "./FinesModal.vue?vue&type=template&id=b4ed1864&"
import script from "./FinesModal.vue?vue&type=script&lang=js&"
export * from "./FinesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports